import { useContext } from "react";
import { AppContext } from "../App";
import { 
  IoGridOutline,
  IoHeartOutline,
  IoFlaskOutline,
  IoCartOutline,
  IoMedkitOutline,
  IoShieldCheckmarkOutline,
  IoCellularOutline,
  IoChevronForwardOutline,
  IoMedical
} from "react-icons/io5";
import { IoMdMedkit } from "react-icons/io";
import Footer from "./Footer";

export default function HomeBanner2() {
  const appContext = useContext(AppContext);

  const serviceCategories = [
    {
      id: "clinical",
      icon: <IoGridOutline size={24} />,
      title: "Clinical Services",
      desc: "Comprehensive outpatient care, continuity medicine, and structured therapeutic support.",
      subpillars: [
        "Outpatient & General Consultation (OPD)",
        "Family Care Model",
        "Non-Communicable Disease (NCD) Clinic",
        "Minor Surgical Procedures Unit",
        "Mental Health & Counseling"
      ],
      target: 'clinical'
    },
    {
      id: "maternal",
      icon: <IoHeartOutline size={24} />,
      title: "Maternal, Child & Reproductive Health",
      desc: "Dedicated clinical paths ensuring long-term wellness for mothers, infants, and families.",
      subpillars: [
        "Maternal & Child Health (MCH) Clinic",
        "Immunization Clinic (EPI)",
        "Cervical Cancer Screening Clinic",
        "Sexual & Reproductive Health (SRH)"
      ],
      target: 'maternal'
    },
    {
      id: "diagnostic",
      icon: <IoFlaskOutline size={24} />,
      title: "Diagnostic Services",
      desc: "Advanced processing suites providing rapid, evidence-based results under safety protocols.",
      subpillars: [
        "Advanced Laboratory Services",
        "Radiology & Diagnostic Imaging (TAEC Compliant)",
        "ECG & Basic Cardiac Rhythm Monitoring"
      ],
      target: 'diagnosis'
    },
    {
      id: "pharmacy",
      icon: <IoMdMedkit size={24} />,
      title: "Pharmacy Services",
      desc: "One-stop clinical repository operating under qualified leadership for prescription fulfillment.",
      subpillars: [
        "Clinical Pharmacy, Screening & Dispensing",
        "Pharmaceutical Products Supply",
        "Biomedical Equipment Access"
      ],
      target: 'pharmacy'
    },
    {
      id: "specialized",
      icon: <IoMedkitOutline size={24} />,
      title: "Specialized Clinics",
      desc: "Targeted medical interventions focused on specific demographic vulnerabilities and requirements.",
      subpillars: [
        "Care and Treatment Clinic (CTC Program)",
        "Occupational Health Services Clinic",
        "Nutrition & Dietetics Clinic",
        "Adolescent Friendly Health Clinic"
      ],
      target: 'specialized'
    },
    {
      id: "wellness",
      icon: <IoShieldCheckmarkOutline size={24} />,
      title: "Wellness & Preventive Care",
      desc: "Packaged, screening-led interventions and medical credentialing for populations and corporate partners.",
      subpillars: [
        "Corporate Wellness Programs",
        "Travel Medicine & International Health Certificates",
        "Health Education Promotion Center"
      ],
      target: 'wellness'
    },
    {
      id: "extended",
      icon: <IoCellularOutline size={24} />,
      title: "Digital & Extended Services",
      desc: "Flexible, technology-driven continuity services extending beyond the traditional clinical floor.",
      subpillars: [
        "Telemedicine / Remote Consultation",
        "Home Sample Collection Service",
        "Medical Records & Health Certificate Services"
      ],
      target: 'telehealth'
    }
  ];

  return (
    <>
      

      <section className="services-section">
        <div className="services-container">
          
          <div className="services-header-flex">
            <div className="services-intro">
              <h2 className="services-heading">Clinical Services</h2>
              <p className="services-subheading">
                Nanguba Health has organized its healthcare ecosystem into seven specialized departments, delivering 23 distinct health care services. These integrated services span clinical, diagnostic, and specialty care pathways, all designed around a patient-first philosophy and a commitment to highest standards of quality and excellence in healthcare delivery.
              </p>
            </div>
          </div>

          <div className="services-grid">
            {serviceCategories.map((category) => (
              <button 
                key={category.id} 
                className="service-card" 
                onClick={() => appContext.navTo({ item: "services", subItem: category.target })}
                aria-label={`Explore ${category.title}`}
              >
                <div className="service-icon-box">
                  {category.icon}
                </div>
                
                <h3 className="service-card-title">{category.title}</h3>
                <p className="service-card-desc">{category.desc}</p>
                
                <ul className="subpillar-list">
                  {category.subpillars.map((sub, idx) => (
                    <li key={idx} className="subpillar-item">
                      <span className="subpillar-dot" />
                      {sub}
                    </li>
                  ))}
                </ul>

                <div className="service-action-link">
                  View Framework Details <IoChevronForwardOutline />
                </div>
              </button>
            ))}
          </div>

        </div>
      </section>
      <Footer/>
    </>
  );
}